/**
 * Ét navn på en vare, det samme alle steder.
 *
 * Listen viste `model_long_name || model_short_name`, mens produktsiden viste
 * `display_name`. For et spil betyder det:
 *
 *   listen:        "Rockstar Games 5026555424271"
 *   produktsiden:  "Rockstar Games Grand Theft Auto V (Premium Edition) - Sony PlayStation 4"
 *
 * Proshops spilsider oplyser INTET produktnavn i de felter vi scraper. `model`
 * er varens EAN, og `productName` er tom, så mærke plus model bliver til mærke
 * plus stregkode. Det rigtige navn ligger i display_name, som allerede er
 * udfyldt, og i indekset hele tiden. Listen kiggede bare aldrig efter det.
 *
 * Rækkefølgen er den samme som resten af systemet bruger: custom_h1_header er
 * den manuelle vej ind og vinder over alt, se UpdateProductRequest.
 */
export function produktnavn(vare) {
    if (!vare) {
        return '';
    }

    return (
        vare.custom_h1_header ||
        vare.display_name ||
        vare.model_long_name ||
        vare.model_short_name ||
        vare.model ||
        ''
    );
}

export function useProduktnavn() {
    return { produktnavn };
}
